import ExamBuilder from "../../components/exam/ExamBuilder";

export default function UserCreate() {
    return (
        <div>
            <h1>Exam Builder</h1>
            <ExamBuilder />
        </div>
    );
}